import { getNoticList, uploadNoticPicture } from "@/api/modules/notic";
import { createAsyncThunk } from "@reduxjs/toolkit";

// 删除常见问题
export const getNoticListAction = createAsyncThunk(
  "notic/getNoticList",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await getNoticList(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
);


export const uploadNoticPictureAction = createAsyncThunk(
  "notic/uploadNoticPicture",
  async (params: any) => {
    // getUserChannels函数是一个axios的请求
    const result: any = await uploadNoticPicture(params);
    if (!result.error) return result.data;
    else {
      return Promise.reject(result.error);
    }
  }
)